import React from "react";
import './Contact.css'
import { ImageTitle } from '../../components/ImageTitle'
import Typography from "@mui/material/Typography";
import { Header } from "../../components/Header";
import { Helmet } from "react-helmet";

interface ContactProps {
    imageUrl: string;
    title: string;
    path: string;
}

const Contact: React.FC<ContactProps> = ({ imageUrl, title, path }) => {

    return (
        <>
            <Header variant={2} />
            <ImageTitle imageUrl={imageUrl} title={title} path={path} />

            <div className="contact">
                <div className="part left-part">
                    <Typography
                        sx={{
                            color: '#ff6c00',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            letterSpacing: '3px',
                            marginBottom: '5px'
                        }}
                    >
                        Contáctanos
                    </Typography>
                    <Typography
                        sx={{
                            color: '#3b3b3b',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '40px',
                            fontWeight: '600',
                            marginBottom: '25px'
                        }}
                    >
                        ¿Necesitas ayuda?
                    </Typography>
                    <Typography
                        sx={{
                            color: '#656565',
                            fontFamily: 'Heebo, sans-serif',
                            fontWeight: 400,
                            marginBottom: '30px',
                            textAlign: 'justify',
                        }}
                    >
                        Nuestro equipo experto está siempre disponible para brindarte asesoria y asistencia cuando lo requieras.
                    </Typography>


                    <div className="section">
                        <div className="icon-contact">
                            <img src='/Assets/icons/ubicacion.png' alt='grupo' style={{ height: '55px' }} />
                            <div>
                                <Typography
                                    sx={{
                                        color: '#3b3b3b',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '20px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Oficina Duitama
                                </Typography>
                                <p style={{
                                    color: '#656565',
                                    fontFamily: 'Heebo, sans-serif',
                                    fontSize: '16px',
                                    fontWeight: '400',
                                }}>
                                    Calle 9 #26-98
                                </p>
                            </div>
                        </div>

                        <div className="icon-contact">
                            <img src='/Assets/icons/ubicacion.png' alt='grupo' style={{ height: '55px' }} />
                            <div>
                                <Typography
                                    sx={{
                                        color: '#3b3b3b',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '20px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Oficina Sogamoso
                                </Typography>
                                <p style={{
                                    color: '#656565',
                                    fontFamily: 'Heebo, sans-serif',
                                    fontSize: '16px',
                                    fontWeight: '400',
                                }}>
                                    Calle 9 #26-98
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="section">
                        <div className="icon-contact" style={{ marginRight: '55px' }}>
                            <img src='/Assets/icons/telefono.png' alt='grupo' style={{ height: '55px' }} />
                            <div>
                                <Typography
                                    sx={{
                                        color: '#3b3b3b',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '20px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Celular
                                </Typography>
                                <p style={{
                                    color: '#656565',
                                    fontFamily: 'Heebo, sans-serif',
                                    fontSize: '16px',
                                    fontWeight: '400',
                                }}>
                                    3107727322
                                </p>
                            </div>
                        </div>
                        <div className="icon-contact">
                            <img src='/Assets/icons/email.png' alt='grupo' style={{ height: '65px' }} />
                            <div>
                                <Typography
                                    sx={{
                                        color: '#3b3b3b',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '20px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Correo
                                </Typography>
                                <p style={{
                                    color: '#656565',
                                    fontFamily: 'Heebo, sans-serif',
                                    fontSize: '16px',
                                    fontWeight: '400',
                                }}>
                                    generales@rocaseguros.com
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="part">
                    <Helmet>
                        <script src="//embed.typeform.com/next/embed.js" async></script>
                    </Helmet>
                    <div data-tf-live="01HYY6H1AQ4EWXRRKY8XM64VGR" ></div>
                </div>
            </div>

        </>
    )
}

export default Contact;